import { registerActivityChatCommand } from '@ayocore/activity/client/extensions';

/**
 * Команда `/user` — упоминание пользователя.
 *
 * Inline-команда: очищает инпут и вставляет `@`. Стандартная детекция
 * mention'а в композере (`readMentionSnapshot`) подхватывает trigger
 * и открывает popup со списком сотрудников.
 *
 * Полезно для discoverability — пользователь видит в slash-меню,
 * что можно упомянуть юзера, и узнаёт о shortcut'е `@`.
 */
export const userMentionActivityChatCommand = registerActivityChatCommand({
  id: 'user_mention',
  trigger: 'user',
  label: 'Тегнуть менеджера',
  description: 'Упомянуть в сообщении менеджера, ему придёт уведомление',
  aliases: ['mention', 'at', 'u'],
  inlineHandler: api => api.openUserMention(),
});
